import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from './Icons';
export function FinalCtaSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-sage text-white text-center" data-id="element-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-18">
          <h2 className="text-4xl md:text-5xl font-playfair font-bold mb-10" data-id="element-19">
            Tienes dos caminos frente a ti:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-20">
            <div className="bg-white/10 p-6 rounded-xl border border-white/20 backdrop-blur-sm" data-id="element-21">
              <h3 className="font-playfair font-bold text-xl mb-3 text-gold-light" data-id="element-22">
                Camino A:
              </h3>
              <p className="font-sans text-white/90 leading-relaxed" data-id="element-23">
                Seguir contando calorías, sintiéndote frustrada, cansada y
                viendo cómo tu ropa cada vez te queda más apretada mientras tu
                cortisol sigue subiendo.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border border-white shadow-xl text-charcoal transform md:-translate-y-4" data-id="element-24">
              <h3 className="font-playfair font-bold text-xl mb-3 text-sage-dark" data-id="element-25">
                Camino B:
              </h3>
              <p className="font-sans text-charcoal-light leading-relaxed" data-id="element-26">
                Unirte a las miles de mujeres que han decidido trabajar CON sus
                hormonas, no contra ellas. Recuperar tu energía, tu silueta y tu
                paz mental por el precio de una cena.
              </p>
            </div>
          </div>

          <a href="https://www.doctormomstudio.com/cart/52358733168821:1" className="w-full md:w-auto px-10 py-5 bg-gold hover:bg-gold-dark text-white rounded-xl font-sans font-bold text-xl transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-3 group mx-auto" data-id="element-27">
            SÍ, QUIERO RECUPERAR MI METABOLISMO
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-28" />
          </a>
          <p className="mt-4 font-sans text-white/80 text-sm" data-id="element-29">
            Acceso inmediato por solo $37 USD
          </p>
        </motion.div>
      </div>
    </section>;
}